import {
    type FC
} from "react";
import type IDropdownMenuGroupProps from "./type";
import {
    useDropdownMenuContext
} from "../../context";
import {
    useDropdownMenuHeadingInset
} from "../../hook";
import PopoverSurface from "../../../popoverSurface";

const DropdownMenuGroup: FC<IDropdownMenuGroupProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    title
}) => {
    const context = useDropdownMenuContext({
        part: "Group"
    });

    const customTheme = customThemeProp ?? context?.customTheme;

    const insetDynamicStyle = useDropdownMenuHeadingInset({
        part: "Group",
        customTheme
    });

    return <PopoverSurface.Group
        headingStyle={insetDynamicStyle}
        customTheme={customTheme}
        heading={title}
        style={style}
    >
        {children}
    </PopoverSurface.Group>;
};
export default DropdownMenuGroup;
